import markdownit from 'markdown-it';

const md = markdownit({
  html: true,
  linkify: true,
  typographer: true,
  breaks: true,
});

const mdOperator = markdownit({
  linkify: true,
  html: true,
  typographer: false,
});

mdOperator.disable(['list'], true);

md.renderer.rules.link_open = (tokens, idx, options, _env, self) => {

  const targetIndex = tokens[idx].attrIndex('target');
  if (targetIndex < 0) {
    tokens[idx].attrPush(['target', '_blank']);
  }

  const relIndex = tokens[idx].attrIndex('rel');
  if (relIndex < 0) {
    tokens[idx].attrPush(['rel', 'noopener noreferrer']);
  }

  return self.renderToken(tokens, idx, options);
};

md.renderer.rules.linkify = (tokens, idx, options, _env, self) => {
  const token = tokens[idx];
  token.attrPush(['target', '_blank']);
  token.attrPush(['rel', 'noopener noreferrer']);
  return self.renderToken(tokens, idx, options);
};

export const renderMarkdown = (value: string) => makeLinksExternal(md.render(value));
const renderMarkdownOperator = (value: string) => makeLinksExternal(mdOperator.render(value));

export const makeLinksExternal = (message: string) => {
  return message.replace(
    /<a\s+(?![^>]*target=)[^>]*>/gi,
    (match) => match.replace('>', ' target="_blank" rel="noopener noreferrer">')
  ).replace(
    /<a\s+[^>]*target\s*=\s*(['"])((?!_blank)[^'"]*)\1[^>]*>/gi,
    (match, quote, target) => match.replace(`target=${quote}${target}${quote}`, `target="_blank"`)
  ).replace(
    /<a\s+(?![^>]*rel=)[^>]*target="_blank"[^>]*>/gi,
    (match) => match.replace('>', ' rel="noopener noreferrer">')
  );

}

export const renderMessage = (message: string, role: string) => {
  switch (role) {
    case 'AI':
      return renderMarkdown(message);
    case 'OPERATOR':
      return renderMarkdownOperator(message);
    default:
      return makeLinksExternal(message);
  }
}
